import { Button, Form, Modal } from "react-bootstrap";
import { useState } from "react";
import { Wager } from "../types";

interface BetCreationModalProps {
  wager: Wager;
  onSubmit: Function;
  show: boolean;
  onClose: Function;
}

export default function BetCreationModal(props: BetCreationModalProps) {
  const [betAmount, setBetAmount] = useState(0);
  const [betOutcome, setBetOutcome] = useState(0);

  return (
    <Modal show={props.show} onHide={() => props.onClose()}>
      <Modal.Header closeButton>
        <Modal.Title>Place bet</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Control
          type="number"
          value={betAmount}
          onChange={(e) => setBetAmount(Number(e.target.value))}
        />
        <Form.Select
          aria-label="Default select example"
          onChange={(e) => setBetOutcome(Number(e.currentTarget.value))}
        >
          <option>Select an outcome</option>
          {props.wager.outcomes.map((outcome, index) => (
            <option key={index} value={index}>
              {outcome}
            </option>
          ))}
        </Form.Select>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => props.onClose()}>
          Close
        </Button>
        <Button
          variant="primary"
          onClick={() =>
            props.onSubmit({
              total: betAmount,
              outcome: betOutcome,
              wagerId: props.wager.id,
            })
          }
        >
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
